import React from 'react';
import PropTypes from 'prop-types';
import { Divider, Hidden, withStyles } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { FormattedMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import messages from 'aurora-translations';
import styles from './styles';

function SelectPMAType(props) {
  const { classes, PMAType, setPMAType } = props;

  let selectedAccount = localStorage.getItem('selectedAccount');
  let isDeveloperAccount = false;
  if (selectedAccount) {
    selectedAccount = JSON.parse(selectedAccount);
    isDeveloperAccount = selectedAccount?.customerType?.includes('DEVELOPER');
  }
  return (
    <Grid item xs={12}>
      <Paper variant='outlined' className={classes.paperCardFrame}>
        <div className={classes.titleHead}>
          <Typography variant='h6' component='h1' className={classes.Title}>
            <FormattedMessage {...messages.pma_type} />
          </Typography>
        </div>
        <Grid container xs={12}>
          <Grid item xs={12} spacing={3} justifyContent='start'>
            <RadioGroup
              className={classes.radioGroup}
              row
              name='PMAType'
              value='PMC'
              onChange={e => setPMAType(e.target.value)}
            >
              <Grid item xs={12} md={5}>
                <FormControlLabel
                  className={classes.radio}
                  value='PMC'
                  checked={PMAType === 'PMC'}
                  control={<Radio classes={{ root: classes.radioCheck, checked: classes.checked }} />}
                  label={<FormattedMessage {...messages.PMC} />}
                />
                <Hidden mdUp>
                  <Divider />
                </Hidden>
              </Grid>
              {isDeveloperAccount && (
                <Grid item xs={12} md={7}>
                  <FormControlLabel
                    className={classes.radio}
                    value='FreeholdPropertyManagementAgreement'
                    checked={PMAType === 'FreeholdPropertyManagementAgreement'}
                    control={<Radio classes={{ root: classes.radioCheck, checked: classes.checked }} />}
                    label={<FormattedMessage {...messages.FreeholdPropertyManagementAgreement} />}
                  />
                  <Hidden mdUp>
                    <Divider />
                  </Hidden>
                </Grid>
              )}
              {isDeveloperAccount && (
                <Grid item xs={12} md={12}>
                  <FormControlLabel
                    className={classes.radio}
                    value='BankWithPossessoryMortgage'
                    checked={PMAType === 'BankWithPossessoryMortgage'}
                    control={<Radio classes={{ root: classes.radioCheck, checked: classes.checked }} />}
                    label='Bank with possessory mortgage'
                  />
                  <Hidden mdUp>
                    <Divider />
                  </Hidden>
                </Grid>
              )}
            </RadioGroup>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
}
SelectPMAType.propTypes = {
  classes: PropTypes.object.isRequired,
  PMAType: PropTypes.string.isRequired,
  setPMAType: PropTypes.func.isRequired,
};
export default withStyles(styles)(SelectPMAType);
